import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Contributor } from '../../contributor'
import { LessonModule } from './lesson-module'

export const LessonModuleToContributor = pgTable(
  'lesson_module_to_contributor',
  {
    lessonModuleId: uuid()
      .notNull()
      .references(() => LessonModule.id, { onDelete: 'cascade' }),
    contributorId: uuid()
      .notNull()
      .references(() => Contributor.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({ columns: [table.lessonModuleId, table.contributorId] }),
    index('lesson_module_to_contributor_module_idx').on(table.lessonModuleId),
    index('lesson_module_to_contributor_contributor_idx').on(table.contributorId),
  ],
)

export const lessonModuleToContributorRelations = relations(LessonModuleToContributor, ({ one }) => ({
  lessonModule: one(LessonModule, {
    fields: [LessonModuleToContributor.lessonModuleId],
    references: [LessonModule.id],
  }),
  contributor: one(Contributor, {
    fields: [LessonModuleToContributor.contributorId],
    references: [Contributor.id],
  }),
}))

export const InsertLessonModuleToContributorSchema = createInsertSchema(LessonModuleToContributor)
export const UpdateLessonModuleToContributorSchema = createUpdateSchema(LessonModuleToContributor).partial()
export const SelectLessonModuleToContributorSchema = createSelectSchema(LessonModuleToContributor)

export type InsertLessonModuleToContributor = typeof LessonModuleToContributor.$inferInsert
export type UpdateLessonModuleToContributor = z.infer<typeof UpdateLessonModuleToContributorSchema>
export type SelectLessonModuleToContributor = typeof LessonModuleToContributor.$inferSelect
